import * as React from 'react';

const PageFooter: React.FC = (): JSX.Element => {
	return (
		<footer className="page-footer">
			<div className="bg-primary-dark">
				<div className="container">
					<div className="d-flex flex-column flex-md-row py-3 justify-content-md-between">
						<span className="small mb-2 mb-md-0 text-white">&copy; Copyright 2026 InsureCPA. All rights reserved.</span>
						<a href="https://www.insurecpa.ca/privacy-policy/" className="small text-white text-decoration-underline" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default PageFooter;
